var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { ActivityIndicator, View, StyleSheet } from 'react-native';
import PartiText from './PartiText';
var FullScreenLoading = function (_a) {
    var style = _a.style, color = _a.color, bgColor = _a.bgColor, text = _a.text, isVisible = _a.isVisible;
    if (!isVisible)
        return null;
    return (React.createElement(View, { style: [styles.container, __assign(__assign({}, style), { backgroundColor: bgColor || 'rgba(0,0,0,0.2)' })] },
        React.createElement(ActivityIndicator, { animating: true, size: "large", color: color || 'white' }),
        React.createElement(PartiText, { style: { color: color } }, text)));
};
var styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
    },
});
export default FullScreenLoading;
